// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1278":"4-auth-msal","57798":"4-feat-protobuf-request","83660":"2-polyfill-idle"}[chunkId] || chunkId) + ".js";
};